export default __webpack_public_path__ + "static/media/F.93bf1925.svg";